import { render } from "./SubmissionHistory.vue?vue&type=template&id=516a1347"
import script from "./SubmissionHistory.vue?vue&type=script&lang=js"
export * from "./SubmissionHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__